import { feetToMillimeters } from "@tedivo/tedivo-pure-helpers";

export const EIGHTANDHALF_FEET_IN_MM = feetToMillimeters(8.5);
export const EIGHT_FEET_IN_MM = feetToMillimeters(8);
export const NINE_SIX_FEET_IN_MM = feetToMillimeters(9.6);

/** Container height in feet assumed when the consumer doesn't provide one */
export const DEFAULT_AVERAGE_CONTAINER_HEIGHT_IN_FEET = 8.5;

export const BOTTOM_BASE_IN_MM = 1000;
export const MID_HEIGHT_SEPARATION_TO_DECK = 0;
